<template>
  <el-card class="box-card experience-wrapper--section-extras" shadow="never">
    <div slot="header" class="clearfix">
      <el-form :model="form" class="form-filter" @submit.native.prevent>
        <el-form-item>
          <el-input
            v-model="form.search"
            :placeholder="$t(`${base}.placeholder.search`)"
            size="large"
            prefix-icon="el-icon-search"
          >
            <el-button slot="append" type="success">{{
              $t(`${base}.form.search`)
            }}</el-button>
          </el-input>
        </el-form-item>
      </el-form>
    </div>

    <div class="experience-wrapper--section-extras-content">
      <div class="section section-extras">
        <el-collapse v-model="activeExtras" class="lad-el-collapse">
          <el-collapse-item
            v-for="(product, i) in productsList"
            :key="i"
            :name="i"
            :title="product.name"
          >
            <template slot="title">
              {{ product.name }}
              <LadExtraPrice
                :product="product"
                :currency="currency"
                :base="base"
              />
            </template>

            <div v-html="product.description"></div>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>
  </el-card>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'LadTabExtras',
  components: {
    LadExtraPrice: () =>
      import(/* webpackChunkName: "lad-extra-price" */ './price'),
  },
  data() {
    return {
      base: 'experience.extras',
      activeExtras: [],
      queries: [],
      form: { search: null },
    }
  },
  computed: {
    ...mapGetters('device', ['isMobile']),
    ...mapState('settings', ['currency']),
    ...mapState('experience', {
      exItems: (state) =>
        [].concat(
          state.extras,
          state.rooms,
          state.insurances,
          state.flights
        ) /** exExtras & exInsurances & exRooms & exFlights */,
      permalink: (state) => state.experience.permalink.default,
      type: (state) => state.experience.type,
    }),
    productsList() {
      return this.form.search
        ? this.exItems.filter((f, i) => {
            const name = f.name.removeDiacritical()
            const description = f.description.removeDiacritical()
            const search = this.form.search.removeDiacritical()

            return name.includes(search) || description.includes(search)
          })
        : this.exItems
    },
    tabRoute() {
      return {
        name: 'product-permalink',
        params: {
          type: this.$t(`router.product_permalink.type.${this.type}`),
          permalink: this.permalink,
        },
      }
    },
  },
  watch: {
    productsList(newValue) {
      if (this.form.search) {
        this.queries = this.form.search.split(' ')
        this.activeExtras = [...Array(this.productsList.length).keys()]
      } else {
        this.queries = []
        this.activeExtras = []
      }
    },
  },
}
</script>

<style lang="scss">
.experience-wrapper--section-extras {
  .el-form-item {
    margin-bottom: 0;
  }

  .el-card__body {
    padding: 0;
  }

  .extra-price {
    margin-left: auto;
    font-size: 0.8em;
    color: #4c4f56;
    font-weight: normal;
  }

  .el-collapse-item__arrow {
    margin: 0 10px;
  }
}
</style>
